import React, { forwardRef } from 'react';
import { BsSearch } from 'react-icons/bs';
import { Flex, Icon, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { inputFocusStyle } from '../../styles/theme/components/input';
import colors from '../../styles/theme/foundation/colors';

const SearchInputGroup = forwardRef(({ searchTerm,
  onChange,
  dataAnalyticsId = '',
  variant = 'primary',
  size = 'md',
  placeHolder = 'Search', width, cypressId, ...styles }, ref) => (
    <InputGroup
      alignItems="center"
      as={Flex}
      justifyContent="flex-end"
      {...styles}
    >
      <InputLeftElement
        children={<Icon as={BsSearch} boxSize="24px" color={colors.greyScale['600']} />}
        height={size === 'sm' ? '32px' : '40px'}
        pointerEvents="none"
        zIndex={1}
      />
      <Input
        _focus={inputFocusStyle}
        data-analytics-id={dataAnalyticsId}
        data-cy={cypressId}
        placeholder={placeHolder}
        ref={ref}
        size={size}
        value={searchTerm}
        variant={variant}
        w={width || '100%'}
        onChange={onChange}
        onKeyDown={evt => {
          if (evt.keyCode === 13) evt.preventDefault();
        }}
      />
    </InputGroup>
));

SearchInputGroup.propTypes = {
  /** Term to filter on. Update `searchTerm` from the control to see the prop value change  */
  searchTerm: PropTypes.string,
  /** Function that handles filtering */
  onChange: PropTypes.func,
  /** Helpful for analytics */
  dataAnalyticsId: PropTypes.string,
  /** `primary` is grey background. `secondary` is white background */
  variant: PropTypes.oneOf(['primary', 'secondary']),
  /** Text to appear before anything is typed */
  placeHolder: PropTypes.string,
  /** `sm` is `32px`, `md` is `40px` */
  size: PropTypes.oneOf(['sm', 'md']),
  /** Width of input group */
  width: PropTypes.string
};

SearchInputGroup.displayName = 'SearchInputGroup';

export default SearchInputGroup;
